import { render, staticRenderFns } from "./PlpProducts26.vue?vue&type=template&id=2998491c&scoped=true"
import script from "./PlpProducts26.vue?vue&type=script&lang=js"
export * from "./PlpProducts26.vue?vue&type=script&lang=js"
import style0 from "./PlpProducts26.vue?vue&type=style&index=0&id=2998491c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998491c",
  null
  
)

export default component.exports